module.exports = __webpack_public_path__ + "static/beetroot_extract-8b93f74d950417202ad7d2d31fa4b782.png";